import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GroupServingContainer from 'PointOfSale/modules/group/container/GroupServingContainer';
import LookUpContainer from 'PointOfSale/modules/lookup/container/LookUpContainer';

class GroupContainer extends Component {
  render() {
    return (
      <React.Fragment>
        {this.props.showLookUp ? (
          <LookUpContainer />
        ) : (
          <GroupServingContainer />
        )}
      </React.Fragment>
    );
  }
}

GroupContainer.propTypes = {
  showLookUp: PropTypes.bool
};

const mapStateToProps = state => ({
  showLookUp: state.PointOfSaleState.lookUp.showLookUp
});

export default connect(mapStateToProps)(GroupContainer);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/group/container/GroupContainer.js